// video load

import NProgress from 'nprogress';

import config from './globals/config';

export default function (loadingSpinner, videoId, player) {

  // on iPhone loaddata doesn't fire, so can't turn this off
  //if( player.id() !== "myMobilePlayer" && player.id() !== "mobileTrailerPlayer" ) {
  if (player.id() !== 'myMobilePlayer' && player.id() !== 'mobileTrailerPlayer') {
    loadingSpinner.show();
  }

  player.catalog.getVideo(videoId, function (error, video) {
    config.myPlayer.catalog.load(video);
    config.myPlayer.play();

    NProgress.done();
  });
}
